import { render } from "./VUEHeader.vue?vue&type=template&id=275e4840"
import script from "./VUEHeader.vue?vue&type=script&lang=js"
export * from "./VUEHeader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__